<template>
  <div>
    <slot></slot>
    <NewLibraryButton
      color-type="dark-blue"
      :class="isBottom ? 'bottom-fixed' : ''"
      class="w-full"
      :disabled="disabled"
      @click="completePayment"
    >
      Confirm
    </NewLibraryButton>
  </div>
</template>

<script>
import NewLibraryButton from "@/NewLibrary/Button.vue";
import { notify } from '@/utils/notify';

export default {
  components: {
    NewLibraryButton
  },
  props: {
    chargeItemCount: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },

  emits: ["completePayment"],
  computed: {
    isBottom() {
      return document.location.href.includes('/ordertest') 
        && !document.location.href.includes('order-center');
    }
  },
  methods: {
    completePayment() {
      if (this.chargeItemCount === 0) {
        notify({ type: 'error', message: 'Must order at least one test' });
        return;
      }
      this.$emit("completePayment");
    },
  }
}
</script>

<style scoped>
.bottom-fixed {
  position: fixed;
  bottom: 89px; 
  z-index: 1000; 
  width: 373px;
  height: 42px;
  right: 52px;
}
</style>